import { Space, theme, Typography } from "antd";
import { AutoCenter, Button } from "antd-mobile";
import { FC, useCallback, useContext } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { styled } from "styled-components";
import { routes } from "../../App";
import GraiaIcon from "../../assets/GraiaIcon";
import AppBaseLayout from "../../components/layouts/AppBaseLayout";
import CenterContent from "../../components/layouts/CenterContent";
import { UserManagerContext } from "../../providers/auth/UserManagerProvider";
import { useGetAgentStateQuery, useGetBusinessUnitsQuery, useLoginMutation } from "../../redux/apis/blenderApi";
import { selectAuthInfo } from "../../redux/slices/authSlice";

const { Title } = Typography;

const LoginPage: FC = () => {
  const { token } = theme.useToken();
  const navigate = useNavigate();

  const userManager = useContext(UserManagerContext);

  const { user } = useSelector(selectAuthInfo);

  const { data: agentState } = useGetAgentStateQuery();
  const { data: businessUnits } = useGetBusinessUnitsQuery();
  const [loginToBlender] = useLoginMutation();

  const handleLogIn = useCallback(
    () => {
      void loginToBlender()
        .then(() => {
          if (agentState && agentState.allowBusinessUnitSelection) {
            if (businessUnits && businessUnits.length < 2)
              void navigate(routes.home);
            else
              void navigate(routes.businessUnitsLogin);
          }
          else {
            void navigate(routes.home);
          }
        });
    },
    [agentState, businessUnits, loginToBlender, navigate],
  );

  const handleSwitchAccount = useCallback(
    () => {
      void userManager.signoutRedirect();
    },
    [userManager],
  );

  return (
    <AppBaseLayout
      appContent={
        <CenterContent $backgroundColor={token.colorPrimaryBg} $padding={token.padding}>
          <StyledSpace direction="vertical" size="large" align="center">
            <StyledGraiaIcon />
            <AutoCenter style={{ textAlign: "center" }}>
              <Title level={2}>Welcome</Title>
              <Title level={2}>{`${user.name}!`}</Title>
            </AutoCenter>
            <Button color="primary" onClick={handleLogIn}>Log in to Graia</Button>
          </StyledSpace>
          <ButtonContainer>
            <Button color="primary" fill="none" onClick={handleSwitchAccount}>Switch account</Button>
          </ButtonContainer>
        </CenterContent>
      }
    />
  );
};

export default LoginPage;

const StyledSpace = styled(Space)`
  flex: 1 1 auto;
  justify-content: center;
`;

const ButtonContainer = styled.div`
  flex: 0 0 auto;
  padding: ${p => p.theme.paddingLG}px;
  text-align: center;
  background-color: ${p => p.theme.colorPrimaryBg};
  color: ${p => p.theme.colorPrimary};
`;

const StyledGraiaIcon = styled(GraiaIcon)`
  width: ${p => p.theme.sizeXXL}px;
  height: ${p => p.theme.sizeXXL}px;
  color: ${p => p.theme.colorPrimary};
`;
